export const osnEnIcon = {
  // eslint-disable-next-line max-len
  data: `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 22.942H18V20.409H8.75462V13.0317H16.7018L17.0818 10.562H8.75462V3.53298H17.7784V1H6V22.942Z" fill="currentColor"/></svg>`,
  name: 'en',
};
